import React from "react";
import styles from "./ShippingControl.module.sass";
import cn from "classnames";
import Icon from "../../../../../components/Icon";
import { useContext } from "react";
import { GlobalState } from "../../../../../App";


const ShippingControl = ({ className, visibleActions, setVisibleActions, up, data, setShowPopup }) => {

  // console.log("in ctrl:", data)
  const { setActiveShippingMethod, shippingMethodList, setShippingMethodList,
    setDeleteShippingMethodIds, setShowShippingMethodPopup, setShowModalViewShippingMethods } = useContext(GlobalState)

  const deleteFunc = () => {
    for (let index = 0; index < shippingMethodList.length; index++) {
      if (shippingMethodList[index]?.id === data?.id) {
        setDeleteShippingMethodIds((oldData) => [...oldData, data?.id])
        setShippingMethodList(shippingMethodList.filter(list => {
          if (list?.id !== data?.id) {
            return list
          }
        }
        ))
      }
    }
  }

  return (
    <div className={cn(styles.control, className)}>
      <button onClick={async () => {
        await setActiveShippingMethod({ id: data?.id, title: data?.title, value: data?.value })
        setShowShippingMethodPopup(true)
        setShowModalViewShippingMethods(true)
      }} className={styles.button}>
        <Icon name="edit" size="15" />
      </button>

      {/* <button onClick={() => {
        deleteFunc()
      }} className={styles.button}>
        <Icon name="trash" size="15" />
      </button> */}
    </div>
  );
};

export default ShippingControl;
